/* eslint-disable jsx-a11y/anchor-is-valid */
import { FC } from "react";
import {
  setBookingModalStatus,
  setEventModalStatus,
  setFormDetails,
  setForumModalStatus,
  setMemberPlanModalStatus,
  setMemberSubscriptionModalStatus,
  setNewsModalStatus,
  setPlanModalStatus,
  setRoomModalStatus,
  setSubscriptionModalStatus,
  setTaskModalStatus,
  setUserModalStatus,
  setUserShowModalStatus,
  setWebpageModalStatus,
} from "../../../../../../../redux/features/shared/sharedSlice";
import { useDispatch, useSelector } from "react-redux";
import { conFirmMessage } from "../../../../../../../utils/shared";


import { Dropdown } from "react-bootstrap";
import ThreeDotsIcon from "../../../../../../../_metronic/assets/logo/ThreeDotsIcon";
import { Link } from "react-router-dom";
import { deleteUser } from "../../../../../../../redux/features/user/_userAction";
import { deleteEvent } from "../../../../../../../redux/features/event/_eventAction";
import { deleteBooking } from "../../../../../../../redux/features/booking/_bookingAction";
import { deleteRoom } from "../../../../../../../redux/features/room/_roomAction";
import { KTIcon, toAbsoluteUrl } from "../../../../../../../_metronic/helpers";
import { deleteTask } from "../../../../../../../redux/features/task/_taskAction";
import { deleteForum } from "../../../../../../../redux/features/forum/_forumAction";
import { deleteNews } from "../../../../../../../redux/features/news/_newsAction";
import ExportIcon from "../../../../../../icons/ExportIcon";
import exportFromJSON from "export-from-json";
import { deleteMemberSubscription, deleteSubscription } from "../../../../../../../redux/features/subscription/_subscriptionAction";
import { deleteMemberPlan, deletePlan } from "../../../../../../../redux/features/plan/_planAction";
import { deleteWebpage } from "../../../../../../../redux/features/webpage/_webpageAction";

const headers = {
  "firstName": "First Name",
  "lastName": "Last Name",
  "phone": "Phone",
  "email": "Email",
  "gender": "Gender"
};

type Props = {
  user: any;
};

const ActionCell: FC<Props> = ({ user }) => {
  const dispatch: any = useDispatch();
  const sharedActions = useSelector((state: any) => state.sharedActions);

  const openEditModal = () => {
    dispatch(setFormDetails(user));
    switch (sharedActions.id) {
      case "User":
        dispatch(setUserModalStatus(true));
        break;
      case "Event":
        dispatch(setEventModalStatus(true));
        break;
      case "Booking":
        dispatch(setBookingModalStatus(true));
        break;
      case "Room":
        dispatch(setRoomModalStatus(true));
        break;
      case "Task":
        dispatch(setTaskModalStatus(true));
        break;
      case "Forum":
        dispatch(setForumModalStatus(true));
        break;
      case "Newsletter":
        dispatch(setNewsModalStatus(true));
        break;
      case "Plan":
        dispatch(setPlanModalStatus(true));
        break;
      case "Subscription":
        dispatch(setSubscriptionModalStatus(true));
        break;
      case "MemberPlan":
        dispatch(setMemberPlanModalStatus(true));
        break;
      case "MemberSubscription":
        dispatch(setMemberSubscriptionModalStatus(true));
        break;
      case "Webpage":
        dispatch(setWebpageModalStatus(true));
        break;
      default:
    }
  };
  const openUserDetailsModal = () => {
    console.log(user)
    dispatch(setFormDetails(user));
    dispatch(setUserShowModalStatus(true));
  };

  const handleDelete = (itemId) => {
    const values = {
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    };
    conFirmMessage(values).then((result) => {
      if (result.isConfirmed) {
        if (sharedActions.id === "Event") {
          setTimeout(() => {
            dispatch(deleteEvent({ id: user?._id, selectedPage: sharedActions.selectedPage }));
          }, 100);
        } else if (sharedActions.id === "User") {
          setTimeout(() => {
            dispatch(deleteUser({ id: user?._id, selectedPage: sharedActions.selectedPage }));
          }, 100);
        } else if (sharedActions.id === "Booking") {
          setTimeout(() => {
            dispatch(deleteBooking({ id: user?._id, selectedPage: sharedActions.selectedPage }));
          }, 100);
        } else if (sharedActions.id === "Room") {
          setTimeout(() => {
            dispatch(deleteRoom({ id: user?._id, selectedPage: sharedActions.selectedPage }));
          }, 100);
        }
        else if (sharedActions.id === "Task") {
          setTimeout(() => {
            dispatch(deleteTask({ id: user?._id, selectedPage: sharedActions.selectedPage }));
          }, 100);
        }
        else if (sharedActions.id === "Forum") {
          setTimeout(() => {
            dispatch(deleteForum({ id: user?._id, selectedPage: sharedActions.selectedPage }));
          }, 100);
        } else if (sharedActions.id === "Newsletter") {
          setTimeout(() => {
            dispatch(deleteNews({ id: user?._id, selectedPage: sharedActions.selectedPage }));
          }, 100);
        }
        else if (sharedActions.id === "Subscription") {
          setTimeout(() => {
            dispatch(deleteSubscription({ id: user?._id, selectedPage: sharedActions.selectedPage }));
          }, 100);
        } else if (sharedActions.id === "MemberSubscription") {
          setTimeout(() => {
            dispatch(deleteMemberSubscription({ id: user?._id, selectedPage: sharedActions.selectedPage }));
          }, 100);
        }
        else if (sharedActions.id === "Plan") {
          setTimeout(() => {
            dispatch(deletePlan({ id: user?._id, selectedPage: sharedActions.selectedPage }));
          }, 100);
        } else if (sharedActions.id === "MemberPlan") {
          setTimeout(() => {
            dispatch(deleteMemberPlan({ id: user?._id, selectedPage: sharedActions.selectedPage }));
          }, 100);
        }else if (sharedActions.id === "Webpage") {
          setTimeout(() => {
            dispatch(deleteWebpage({ id: user?._id, selectedPage: sharedActions.selectedPage }));
          }, 100);
        }
      }
    });
  };

  function downloadXml() {
    const data = [user];   //dataForXml
    const fileName = user?.firstName;//fieldsAsObjects or fieldsAsStrings, empty list means "use all"
    const exportType = 'xml';
    const fields = headers || []
    exportFromJSON({ data, fileName, fields, exportType })
  }

  return (
    <>
      <div className="d-flex align-items-center">
        <div className="menu-item me-4">
          <Dropdown className="verifiedOptions">
            <Dropdown.Toggle variant="default" id="dropdown-basic">
              <ThreeDotsIcon />
            </Dropdown.Toggle>

            <Dropdown.Menu>
              {user?.role?.includes("member") && (
                <Link
                  to={"#"}
                  className="menu-link justify-content-start px-3 btn  btn-active-light-primary btn-sm"
                  onClick={openUserDetailsModal}
                >
                  <img src={toAbsoluteUrl('/media/avatars/detailIcon.png')} className="img-class" alt='img' />
                  Details
                </Link>
              )}
              {(sharedActions.id !== "Task" || (sharedActions.id === "Task" && user.status != 'completed')) && (<Link
                to={"#"}
                className="menu-link justify-content-start px-3 btn  btn-active-light-primary btn-sm"
                onClick={openEditModal}
              >
                <KTIcon iconName="pencil" className="fs-2" /> Edit
              </Link>)}
              { <Link
                to={"#"}
                className="menu-link px-3 btn justify-content-start  btn-active-light-primary btn-sm"
                data-kt-users-table-filter="delete_row"
                onClick={async () => await handleDelete(user._id)}
              >
                <KTIcon iconName="trash" className="fs-2 text-danger" /> Delete
              </Link>
}
              {sharedActions.id == "User" &&
                <Link to={'#'} onClick={downloadXml} className='bg-light-primary menu-link px-3 btn justify-content-start  btn-active-light-primary btn-sm'>
                  <ExportIcon />
                  <span className="ms-1">Export</span>
                </Link>
              }
            </Dropdown.Menu>
          </Dropdown>

          {/* <a
            className="menu-link px-3 btn btn-secondary btn-active-light-primary btn-sm"
            onClick={openEditModal}
          >
            Edit
          </a> */}
          {/* </div> */}
          {/* <div className="menu-item">
          <a
            className="menu-link px-3 btn btn-danger btn-active-light-primary btn-sm"
            data-kt-users-table-filter="delete_row"
            onClick={async () => await handleDelete(user._id)}
          >
            Delete
          </a>
        </div> */}
        </div>
      </div>
    </>
  );
};

export { ActionCell };
